import { Text } from '@iwoca/orion';

// Stands in for each step page until its ticket builds it.
export const StepPlaceholder = () => {
    return (
        <Text className="text-l" data-testid="step-placeholder">
            This step isn&apos;t available yet.
        </Text>
    );
};
